module.exports = __webpack_public_path__ + "img/3.a3ea38c3.jpg";